import React from 'react';

import cs from 'classnames';

const ReportItemSkeleton = () => {
  return (
    <div
      className={cs(
        'group flex items-center justify-between gap-4',
        'border-0 border-b border-solid border-neutral-200'
      )}>
      <div className="flex flex-1 cursor-pointer items-center gap-2 p-2">
        <div className="h-4 w-40 animate-pulse rounded bg-gray-300"></div>
      </div>
      <div className="flex items-center gap-2">
        <div className="h-5 w-5 animate-pulse rounded-full bg-gray-300"></div>
        <div className="h-5 w-5 animate-pulse rounded-full bg-gray-300"></div>
      </div>
    </div>
  );
};

export default ReportItemSkeleton;
